<script setup lang="ts">
defineProps<{
  value: boolean;
  disabled: boolean;
}>();

const emit = defineEmits(["change"]);
</script>

<template>
  <div :class="[$attrs['class'], 'remove-background']">
    <label class="remove-background__container">
      <div class="remove-background__switch">
        <input
          type="checkbox"
          class="remove-background__input"
          :checked="value"
          :disabled="disabled"
          @click.prevent="emit('change', !value)"
        />
        <span class="remove-background__slider"></span>
      </div>
      <div class="remove-background__label">
        <span>Remove Background</span>
      </div>
    </label>
  </div>
</template>

<style lang="scss" scoped>
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";

.remove-background {
  &__container {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 8px;
    padding: 8px 0;
  }

  &__label {
    color: $black-light;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  &__switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
  }

  &__input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .remove-background__slider {
      background-color: $primary-light;

      &:before {
        transform: translateX(20px);
      }
    }
  }

  &__slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: $silver;
    transition: background-color 0.3s;
    border-radius: 24px;

    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: $white;
      transition: transform 0.3s;
      border-radius: 50%;
    }
  }
}
</style>
